import { render, staticRenderFns } from "./SelectDown.vue?vue&type=template&id=50d40340&scoped=true&"
import script from "./SelectDown.vue?vue&type=script&lang=js&"
export * from "./SelectDown.vue?vue&type=script&lang=js&"
import style0 from "./SelectDown.vue?vue&type=style&index=0&id=50d40340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d40340",
  null
  
)

export default component.exports